// extracted by mini-css-extract-plugin
export default {"wrap":"donateFinalMesssage_wrap__vhTgF","donateP":"donateFinalMesssage_donateP__HqkLV","donateImgWrap":"donateFinalMesssage_donateImgWrap__JrQCg"};